<template>
  <div class="row mb-2 py-2 bg-white shadow mx-0 rounded benutzer-row" @click="openBenutzer()">
    <div class="col-4 d-flex my-auto">
      <div v-if="user.enabled" style="width: 30px">
        <font-awesome-icon icon="circle-check" class="text-primary" title="Aktiv" />
      </div>
      <div v-else style="width: 30px">
        <font-awesome-icon icon="circle-info" class="me-1 text-danger" title="Inaktiv" />
      </div>

      {{ user.lastName }}, {{ user.firstName }}
    </div>

    <div class="col-3 my-auto">{{ user.username }}</div>
    <div class="col-5 my-auto">
      <font-awesome-icon v-if="!user.emailVerified" icon="circle-info" class="me-1 text-danger" title="E-Mail nicht verifiziert" /> {{ user.email }}
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType } from 'vue';
  import { useRouter } from 'vue-router';
  import { User } from '@/models/BenutzerModels';

  //#endregion

  const { user, realm } = defineProps({
    user: {
      type: Object as PropType<User>,
      required: true,
    },
    realm: {
      type: String as PropType<string>,
      default: 'admin',
    },
  });

  const router = useRouter();

  function openBenutzer() {
    router.push({ name: 'BenutzerDetails', params: { id: user.id }, query: { realm: realm } });
  }
</script>

<style lang="scss" scoped>
  .benutzer-row:hover {
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #cee0fa !important;
    }
  }
</style>
